import { createContext, useCallback, useMemo, useState } from 'react';

type LoadingContextType = {
  stopLoadingButtonStatus: boolean;
};

type LoadingActionsContextType = {
    onChangeLoadingButtonStatus: () => Promise<void>;
};
export type InterruptedTransactionType = {
  idTag: string;
  sessionId: number;
  connectorId: string;
};

export const LoadingContext = createContext<LoadingContextType | null>(null);
export const LoadingActionsContext =
  createContext<LoadingActionsContextType | null>(null);

export function LoadingProvider({ children }: { children: React.ReactNode }) {
  const [stopLoadingButtonStatus, setStopLoadingButtonStatus] =
    useState<boolean>(false);

  const onChangeLoadingButtonStatus = useCallback(async () => {
    setStopLoadingButtonStatus(true);
  }, []);

  const value = useMemo(
    () => ({
      stopLoadingButtonStatus,
    }),
    [stopLoadingButtonStatus],
  );

  const actions = useMemo(
    () => ({
      onChangeLoadingButtonStatus,
    }),
    [onChangeLoadingButtonStatus],
  );

  return (
    <LoadingContext.Provider value={value}>
      <LoadingActionsContext.Provider value={actions}>
        {children}
      </LoadingActionsContext.Provider>
    </LoadingContext.Provider>
  );
}
